import 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoreAuthService, CoreApiService } from '@rd/core';

import { CredentialsModel } from './shared';

@Component({
  selector: 'rd-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username: string = '';
  password: string = '';
  user = new CredentialsModel();
  errorMessage: string = null;

  constructor(private authService: CoreAuthService, private rdCoreService: CoreApiService, private router: Router) {}

  ngOnInit() {
  }

  onLogin() {
    this.user = {username: this.username, password: this.password};
    // Submit form
    this.authService.login(this.user)
      // TODO: Hopefully this logic will move to the server
      .then( (loginResponse: any) => {
        let userEndpoint = '/users/' + this.authService.userId + '?include=role';
        this.rdCoreService.get(userEndpoint)
          .subscribe((user: any) => {
            if (user.role.id === 1) {
              this.router.navigateByUrl('/');
            } else {
              // Delete all their info
              this.authService.logout();
              this.errorMessage = 'You are not authorized to access this app!';
            }
          });
      })
      .catch( (errorRes) => {
        this.errorMessage = errorRes.message;
      });
  }

  redirectFunction(path) {
    // TODO: Find a better way to redirect this
    this.router.navigateByUrl(path);
  }
}